import { useCssInJs } from "../../../../../hooks";
import { Divider } from 'antd';
import { ReactComponent as TaskCompleteIcon } from "../../../../../assets/svg/icon-task-complete.svg";
import { ReactComponent as TaskCurrentIcon } from "../../../../../assets/svg/icon-task-current.svg";
import { ReactComponent as TaskFinishedIcon } from "../../../../../assets/svg/icon-task-finished.svg";
import { ReactComponent as TaskStartIcon } from "../../../../../assets/svg/icon-task-start.svg";
import cls from 'classnames';
import { getTaskProgressStyle } from "./styles";
import FormView from "../../common/FormView";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TASK_ICON_MAP = {
  NEW_ORDER: TaskCurrentIcon,
  DOING: TaskCurrentIcon,
  FINISHED: TaskCompleteIcon
};
var OPT_TYPE_COLOR_MAP = {
  APPLY: '#606266',
  // 申请
  ACCEPT: '#2BB686',
  // 领取
  APPROVE: '#336DFF',
  // 处理
  REJECT: '#F5222D',
  // 拒绝
  ASSIGN: '#EEB30A',
  // 转交
  REBUT: '#FA8C16',
  // 驳回
  REVOKE: '#6E7E95' // 撤销
};
var OPT_TYPE_BG_COLOR_MAP = {
  REJECT: '#FFE7E9',
  // 拒绝
  ASSIGN: '#FFF6D3',
  // 转交
  REBUT: '#FFF2E3' // 驳回
};
export default function TaskProgress(props) {
  var prefix = 'task-list-task-progress';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getTaskProgressStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var _props$data = props === null || props === void 0 ? void 0 : props.data,
    taskDetails = _props$data.taskDetails,
    initiator = _props$data.initiator,
    operateButtons = _props$data.operateButtons,
    createTime = _props$data.createTime;
  if (!taskDetails || taskDetails.length === 0) {
    return null;
  }
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cls(prefix, hashId),
    children: /*#__PURE__*/_jsxs("div", {
      className: "taskProgressContainer",
      children: [taskDetails.length > 0 ? /*#__PURE__*/_jsx("div", {
        className: cls(prefix, hashId, 'timeline')
      }) : null, taskDetails.map(function (item, index) {
        return /*#__PURE__*/_jsx(TaskNode, {
          data: item,
          index: index,
          onReload: function onReload() {}
        }, item.taskOrderId);
      }), initiator ? /*#__PURE__*/_jsx("div", {
        className: "nodeView whiteBg",
        children: /*#__PURE__*/_jsxs("div", {
          className: "titleView",
          children: [/*#__PURE__*/_jsx("div", {
            className: "icon",
            children: /*#__PURE__*/_jsx(TaskStartIcon, {})
          }), /*#__PURE__*/_jsxs("div", {
            className: "taskProgressContent",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "titleRow",
              children: [/*#__PURE__*/_jsx("p", {
                className: "titleText",
                children: "\u53D1\u8D77\u6D41\u7A0B"
              }), /*#__PURE__*/_jsx("p", {
                className: "timeText",
                children: createTime
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "textBlack",
                children: [initiator.userName, initiator.title]
              }), /*#__PURE__*/_jsx("div", {
                className: "statusText",
                style: {
                  color: OPT_TYPE_COLOR_MAP.APPLY
                },
                children: "\u7533\u8BF7"
              })]
            })]
          })]
        })
      }) : null]
    })
  }));
}
var FINAL_ORDER_STATUS = ['FINISHED', 'SUSPEND'];
function TaskNode(props) {
  var index = props.index;
  var _props$data2 = props === null || props === void 0 ? void 0 : props.data,
    taskNodeName = _props$data2.taskNodeName,
    deadLineTime = _props$data2.deadLineTime,
    finishTime = _props$data2.finishTime,
    timeoutDuration = _props$data2.timeoutDuration,
    handlerList = _props$data2.handlerList,
    taskOpLogs = _props$data2.taskOpLogs,
    taskOrderStatus = _props$data2.taskOrderStatus;
  var isFinished = FINAL_ORDER_STATUS.includes(taskOrderStatus);
  var showHandler = !isFinished && Boolean(handlerList && handlerList.length);
  var NodeIcon = index === 0 && isFinished ? TaskFinishedIcon : TASK_ICON_MAP[taskOrderStatus] || TaskCompleteIcon;
  return /*#__PURE__*/_jsxs("div", {
    className: "nodeView",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "titleView",
      children: [/*#__PURE__*/_jsx("div", {
        className: "icon",
        children: /*#__PURE__*/_jsx(NodeIcon, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: "taskProgressContent",
        children: [/*#__PURE__*/_jsx("div", {
          className: "row",
          children: /*#__PURE__*/_jsx("p", {
            className: "titleText",
            children: taskNodeName || '节点'
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "row",
          children: [finishTime ? /*#__PURE__*/_jsxs("p", {
            className: "text",
            children: [finishTime, " \u5B8C\u6210"]
          }) : null, deadLineTime ? /*#__PURE__*/_jsxs("p", {
            className: "text",
            children: [deadLineTime, " \u524D\u5B8C\u6210"]
          }) : null, timeoutDuration ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Divider, {
              type: "vertical"
            }), /*#__PURE__*/_jsx("p", {
              className: "textDanger",
              children: timeoutDuration
            })]
          }) : null]
        })]
      })]
    }), showHandler ? /*#__PURE__*/_jsxs("div", {
      className: "logView",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "logTitleRow",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pointView",
          children: /*#__PURE__*/_jsx("div", {
            className: "point",
            style: {
              backgroundColor: OPT_TYPE_COLOR_MAP.APPROVE
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("p", {
            className: "text",
            children: "\u5904\u7406\u4EBA"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "taskProgressContent1",
        children: /*#__PURE__*/_jsx("div", {
          className: "userList",
          children: handlerList.length > 0 ? handlerList.map(function (item, index) {
            var _item$userName;
            return /*#__PURE__*/_jsxs("div", {
              className: "userItem",
              children: [/*#__PURE__*/_jsx("div", {
                className: "userAvatar",
                children: /*#__PURE__*/_jsx("div", {
                  className: "minText",
                  children: (_item$userName = item.userName) === null || _item$userName === void 0 ? void 0 : _item$userName.slice(0, 2)
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "fullText",
                children: /*#__PURE__*/_jsx("p", {
                  children: item.userName
                })
              })]
            }, item.userCode || item.userId);
          }) : null
        })
      })]
    }) : null, taskOpLogs && taskOpLogs.length > 0 ? taskOpLogs.filter(function (item) {
      return item.operateType !== 'ACCEPT';
    }).map(function (item, index) {
      return /*#__PURE__*/_jsx(TaskOpItem, {
        data: item
      }, item.opLogId);
    }) : null]
  });
}
function TaskOpItem(props) {
  var _props$data3 = props.data,
    handler = _props$data3.handler,
    formSchema = _props$data3.formSchema,
    formValue = _props$data3.formValue;
  var tintColor = OPT_TYPE_COLOR_MAP[props.data.operateType];
  var bgColor = OPT_TYPE_BG_COLOR_MAP[props.data.operateType];
  return /*#__PURE__*/_jsxs("div", {
    className: "logView",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "logTitleRow",
      children: [/*#__PURE__*/_jsx("div", {
        className: "pointView",
        children: /*#__PURE__*/_jsx("div", {
          className: "point",
          style: {
            backgroundColor: tintColor
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "titleContent",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "row",
          children: [handler ? /*#__PURE__*/_jsxs("div", {
            className: "text",
            children: [handler.userName, handler.title]
          }, handler.userCode || handler.userId) : null, /*#__PURE__*/_jsx("div", {
            className: "statusText",
            style: {
              color: tintColor,
              backgroundColor: bgColor,
              padding: bgColor ? undefined : 0
            },
            children: props.data.operateTypeName
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "timeText",
          children: props.data.handlerTime
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "taskProgressContent1",
      children: /*#__PURE__*/_jsx(FormView, {
        schema: formSchema,
        value: formValue,
        mode: "readOnly"
      })
    })]
  });
}